import { Injectable } from "@angular/core";

import { Field } from "@shared/field.model";
import { TextboxField } from "@shared/field-textbox";
import { productSearchValidator } from "@app/shared/custom-validators";
import { PortalService } from "./portal.service";
import { Validators } from "@angular/forms";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class SearcherFieldService {
  constructor(public portalService: PortalService) {}

  getFields() {
    let fields: Field<any>[] = [
      new TextboxField({
        key: "searchCriteria",
        id: "portal-search",
        label: "Buscador",
        classes: "d-block m-auto",
        value: "",
        config: {
          autofocus: true,
          keyPressEvt: true,
        },
        asyncValidations: [productSearchValidator(this.portalService)],
        validateOn: "submit",
        errorMessages: [
          {
            rule: "productSearch",
            message:
              "Sin resultados para la búsqueda realizada",
          },
        ],
        order: 1,
      }),
    ];
    return fields.sort((a, b) => a.order - b.order);
  }
}
